import * as Toolkit from '../../../toolkit/index';
import * as FrontCubeData from '../../../frontCubeData/index';
import RenderData, { GoodsRenderData } from './renderData';
import CreateGoodsDom from './createGoodsDom';
import { loadingImg } from './loadingImg';

export function renderXLineGoodsFolded(cube: CubeNode): void {
    // x轴叠放商品渲染数据组装
    let xLineGoodsFoldedRenderData: GoodsRenderData = RenderData.xLineGoodsFolded(cube);
debugger
    // x轴叠放商品dom对象
    let $xLineGoodsFolded: JQuery = CreateGoodsDom(cube, xLineGoodsFoldedRenderData);
    let xpileDirection: number = FrontCubeData.getValue(cube.id, 'xpileDirection');
    let goodsFoldedSelector: string = xpileDirection == 1 ? '.J_Left' : '.J_Right';
    let $goodsFolded: JQuery<HTMLElement> = cube.jView.find(goodsFoldedSelector);

    Toolkit.html($goodsFolded, '');
    $goodsFolded.append($xLineGoodsFolded);
    loadingImg($goodsFolded);
}
